import { render, staticRenderFns } from "./AccountDeleted.vue?vue&type=template&id=79e4b51f&scoped=true&"
import script from "./AccountDeleted.vue?vue&type=script&lang=ts&"
export * from "./AccountDeleted.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDeleted.vue?vue&type=style&index=0&id=79e4b51f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4b51f",
  null
  
)

export default component.exports